import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=c256a55e&scoped=true&"
import script from "./Visits.vue?vue&type=script&lang=ts&"
export * from "./Visits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c256a55e",
  null
  
)

export default component.exports